import type { RsPlusSeeTheDifferenceContent } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const rsPlusSeeTheDifferenceContentFallback: RsPlusSeeTheDifferenceContent = {
  internalName: '',
  heading: '',
  body: '',
  ctaLabel: '',
  roadshowCardImage: {
    assetId: '',
    alt: '',
    url: ''
  },
  roadshowCardBadge: '',
  roadshowCardLabel: '',
  roadshowCardBullets: '',
  studioCardImage: {
    assetId: '',
    alt: '',
    url: ''
  },
  studioCardBadge: '',
  studioCardLabel: '',
  studioCardBullets: ''
}
